import { onMounted, onUnmounted, ref } from 'vue'

const isExtensionInstalled = ref(true)
const isExtensionAuthenticated = ref(true)
const extensionId = 'bifaoaidegbcmjliabaeabnniphbaodi'

let pollInterval: NodeJS.Timeout | null = null

export default () => {
  onMounted(() => {
    checkExtensionInstalled()

    pollInterval = setInterval(() => {
      if (!isExtensionInstalled.value) {
        checkExtensionInstalled()
      }
    }, 2000)
  })

  onUnmounted(() => {
    if (pollInterval) {
      clearInterval(pollInterval)
      pollInterval = null
    }
  })

  async function checkExtensionInstalled() {
    const installed = await sendMessageToExtension({ type: 'ping' })
      .then(() => true)
      .catch(() => false)
    isExtensionInstalled.value = installed
  }

  async function checkExtensionAuthenticated() {
    isExtensionAuthenticated.value = await sendMessageToExtension<boolean>({
      type: 'isAuthenticated',
    }).catch(() => false)
  }

  async function loginExtension(recoveryLink: string) {
    const loggedIn = await sendMessageToExtension({
      type: 'login',
      recoveryLink,
      instanceUrl: window.location.origin,
    })
    if (loggedIn === 'success') {
      isExtensionAuthenticated.value = true
    }
  }

  async function logoutExtension() {
    const loggedOut = await sendMessageToExtension({
      type: 'logout',
    })
    if (loggedOut === 'success') {
      isExtensionAuthenticated.value = false
    }
  }
  return {
    isExtensionInstalled,
    isExtensionAuthenticated,
    loginExtension,
    checkExtensionAuthenticated,
    logoutExtension,
  }
}

function sendMessageToExtension<T>(payload: unknown): Promise<T> {
  return new Promise((resolve, reject) => {
    if (!chrome.runtime) {
      reject(new Error('Chrome runtime not available'))
    }
    chrome.runtime.sendMessage(extensionId, payload, function (response) {
      resolve(response)
    })
  })
}
